import { FC } from 'react';
import { PageContainer } from 'components';
import { Dashboard } from 'features/Dashboard';
import { DashboardNew } from 'features/DashboardNew';

export const DashboardPage: FC<{ newOne?: boolean }> = ({ newOne }) => {
  return <PageContainer>{newOne ? <DashboardNew /> : <Dashboard />}</PageContainer>;
};
